export const GOOGLE_RECAPTCHA_KEY = '6LdNq-siAAAAADjEPmtCMLLDOTMKAM3NRvqP_SJD';
